/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize EducationalMaterial Categories View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './eventReportFormView';

export const mapStateToPropsEventReportForm = mapStateToProps;
export const mapDispatchToPropsEventReportForm = mapDispatchToProps;

export default connect(
  mapStateToPropsEventReportForm,
  mapDispatchToPropsEventReportForm
)(View);
